export { default as BannerCreate } from './BannerCreate';
export { default as BannerEdit } from './BannerEdit';
export { default as BannerList } from './BannerList';


// WEBPACK FOOTER //
// ./src/modules/Banner/pages/index.ts